import type { ReactNode } from "react";

type CategoryStoryProps = {
  id: string;
  title: string;
  children: ReactNode;
};

export function CategoryStory({ id, title, children }: CategoryStoryProps) {
  return (
    <section
      className="section category-story reveal-item"
      aria-labelledby={`${id}-title`}
    >
      <h2 id={`${id}-title`}>{title}</h2>
      {children}
    </section>
  );
}
